import { getComposeViewState } from "owa-mail-reading-pane-store-conversation/lib/utils/getComposeViewState";
import { getSelectedTableView, isMultipleSelectedItemParts } from "owa-mail-list-store";

export const getMailContext = (): {
    isComposing: boolean;
    isReading: boolean;
} => {
    const isComposing = !!getComposeViewState();
    
    return {
        isComposing,
        isReading: !isComposing && isReadingOneItem(),
    };
};

const isReadingOneItem = (): boolean => {
    const tableView = getSelectedTableView();
    
    // `getSelectedTableView` is typed wrong and returns `TableView | undefined`
    if (!tableView) {
        return false;
    }
    
    const { isInVirtualSelectAllMode, selectedRowKeys } = tableView;
    
    const hasOneItemSelected: boolean = !isMultipleSelectedItemParts() && selectedRowKeys.size === 1 && !isInVirtualSelectAllMode;
    
    return hasOneItemSelected;
};
